import { useEffect, useState } from "react"
import { useParams, useRouteMatch } from "react-router-dom"

import { useScenarioType } from "../ScenarioTypeContext"

import InterventionsEditorLayout from "./InterventionEditorLayout"

import AddEntity from "../AddEntity"
import InlineEditor from "../InlineEditor"

import { genInterventionRec } from "./types"
import { getIntvsBC } from "../urls"

const InterventionsList = () => {
    const params = useParams()
    const { url } = useRouteMatch()
    const {
        scenarioType,
        intvs,
        intvPrompts,
        intvPromptAnswers,
        intvMenuItems,
        intvMenuCategories,
        uniqueIDs,
        uniqueLabels
    } = useScenarioType()
    const [sortedIntvs, setSortedIntvs] = useState(null)

    const addHandler = (entityType, newID, newLabel) => {
        intvs.add(genInterventionRec(newID, newLabel))
    }

    const deleteHandler = (item) => {
        const myPrompts = scenarioType.interventionPrompts.filter(e => e.interventionID === item.id)
        const myPromptIDs = myPrompts.map(e => e.id)
        const myAnswers = scenarioType.interventionPromptAnswers.filter(e => myPromptIDs.includes(e.promptID))
        const myMenuItems = scenarioType.interventionMenuItems.filter(e => e.interventionID === item.id)
        const myMenuItemIDs = myMenuItems.map(mi => mi.id)
        const myMenuCats = Array.from(new Set(myMenuItems.map(mi => scenarioType.interventionMenuCategories.find(e => e.id === mi.intvCategoryID))))

        let msg = `Are you sure you wish to delete the intervention "${item.label}" and all of it's children?`
        if (myPrompts.length > 0) {
            msg += "\nPrompts:\n"
            msg += myPrompts.map(e => `\t${e.label}`).join("\n")
            msg += "\nAnswers:\n"
            msg += myAnswers.map(e => `\t${e.label}`).join("\n")
        }
        if (myMenuItems.length > 0) {
            msg += "\nIntervention menu items:\n"
            myMenuCats.forEach(cat => {
                msg += `\t${cat.label}:\n`
                cat.items.forEach(itemID => {
                    myMenuItems.forEach(mi => {
                        if (mi.id === itemID) {
                            msg += `\t\t${mi.id}\n`
                        }
                    })
                })
            })
        }
        if (window.confirm(msg)) {
            myAnswers.forEach(e => intvPromptAnswers.remove(e.id))
            myPrompts.forEach(e => intvPrompts.remove(e.id))
            myMenuItems.forEach(e => intvMenuItems.remove(e.id))
            myMenuCats.forEach(cat => {
                const {items, ...newCat} = cat
                const newCatItems = items.filter(itemID => !myMenuItemIDs.includes(itemID))
                newCat.items = newCatItems
                intvMenuCategories.update(newCat)
            })
            intvs.remove(item.id)
        } else {
            alert("deletion aborted")
        }
    }

    useEffect(
        () => {
            setSortedIntvs(intvs.getSorted())
        }, [scenarioType.interventions, intvs]
    )


    if (!sortedIntvs) {
        return (<div>sorting interventions</div>)
    }
    return (
        <InterventionsEditorLayout
            breadcrumbs={[getIntvsBC(params)]}
        >
            <InlineEditor
                heading="Interventions"
                records={sortedIntvs}
                fields={[
                    { name: "id", label: "ID", colWidthPct: 44, widget: "smallText" },
                    { name: "label", label: "Label", colWidthPct: 48, widget: null },
                    { name: "system", label: "System", colWidthPct: 8, widget: "smallText" }
                ]}
                allowChangeOrder={false}
                editLink={true}
                editBaseURL={url}
                onDelete={deleteHandler}
            >
                <AddEntity
                    entitiesDesc={[{type: "intervention", name: "Intervention", labelsUnique: true}]}
                    addHandler={addHandler}
                    uniqueIDs={uniqueIDs}
                    uniqueLabels={uniqueLabels}
                />
            </InlineEditor>
        </InterventionsEditorLayout>
    )
}

export default InterventionsList